export default __webpack_public_path__ + "static/media/023-surfing.ea76e440.svg";